const validate = (inputs) => {
    const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
    let errors = {
        valid: true,
    };

    //name errors
    if (!inputs.firstName) {
        errors.firstNameError = 'Enter your first name';
        errors.valid = false;
    }
    if (!inputs.lastName) {
        errors.lastNameError = 'Enter your last name';
        errors.valid = false;
    }
    //Email errors
    if (!validEmailRegex.test(inputs.email)) {
        errors.emailError = 'Please enter a valid email ID.';
        errors.valid = false;
    } else if (!inputs.email) {
        errors.emailError = 'Please enter a valid email ID.';
        errors.valid = false;
    }
    //Phone errors
    if (inputs?.phone?.length != 10) {
        errors.phoneError = 'Enter a valid mobile number without the country code.'
        errors.valid = false;
    }

    //Password Errors
    if (inputs?.password?.length < 6) {
        errors.passwordError = 'Password must be at least 6 characters long'
        errors.valid = false;
    }
    if (!inputs?.password) {
        errors.passwordError = 'Please enter a valid password'
        errors.valid = false;
    }
    //Confirm Password Errors
    if (inputs.confirmPassword !== inputs.password) {
        errors.confirmPasswordError = 'Please confirm your password.'
        errors.valid = false;
    }
    if (inputs?.confirmPassword?.length < 6) {
        errors.confirmPasswordError = 'Passwords do not match. Please try again.'
        errors.valid = false;
    }
    if (!inputs.confirmPassword) {
        // errors.confirmPasswordError = 'Please enter a valid password'
        errors.confirmPasswordError = 'Please confirm your password.'
        errors.valid = false;
    }

    //Referral ID errors
    if (!inputs.referral_id || inputs.referral_id.length === 0) {
        errors.referral_idError = 'Please select how you heard about us';
        errors.valid = false;
    }

    return errors;
}
export default validate;